import './Sign.scss'
import React, { useState, useEffect } from 'react'
import { Slide } from '@material-ui/core'
import InlineLoader from '../InlineLoader/InlineLoader'
import Head from '../Head/Head'
import axios from '../../utils/axios'
import colors from '../../mixins.scss'
import { Translated, useTranslated } from '../../utils/translated'

const Sign = (props) => {

    const translated = useTranslated();

    const inputRef = React.useRef();

    useEffect(() => {
        if (!props.isShow)
            return

        setTimeout(() => {
            inputRef.current && inputRef.current.focus();
        }, 800);

    }, [props.isShow]);

    const [login, setLogin] = useState('');
    const [error, setError] = useState('');
    const [isCheckingLogin, setIsCheckingLogin] = useState(false);

    const handleLoginKeyDown = (e) => {
        if (e.key === 'Enter')
            handleAuth();
    }

    const handleLoginChange = (value) => {
        validateLogin(value);
        setLogin(value.toLowerCase());
    }

    const validateLogin = (value) => {
        if (!value) {
            setError('Please, enter your login');
            return false;
        } else if (/[*\\:"|<>/?&]+/.test(value)) {
            setError('Symbols < > : " / \\ | ? * & are not allowed to use');
            return false;
        } else {
            setError('');
            return true;
        }
    }

    const handleAuth = async () => {
        if (!validateLogin(login))
            return

        const { status, isExists } = await checkIfLoginExists();
        if (status !== 'success') {
            setError(translated('app.sign.error-connection'));
            return;
        } else if (!props.isSignIn && isExists) {
            setError(translated('app.sign.error-exists'));
            return;
        } else if (props.isSignIn && !isExists) {
            setError(translated('app.sign.error-not-found'));
            return;
        }

        props.onSign(login);
    };

    const checkIfLoginExists = async () => {
        setIsCheckingLogin(true);

        const response = await axios.post('check_login', { login });
        let { status, message } = response;

        setIsCheckingLogin(false);

        if (status !== 'error')
            return { status: 'success', isExists: status === 'login_exists' };
        else return { status: 'error', error: message };
    }

    return (
        <Slide direction={props.direction} in={props.isShow} timeout={{ enter: 800, exit: 500 }} mountOnEnter unmountOnExit>
            <div className='sign'>
                <Head
                    isShow={true}
                    width='70'
                    height='85' />

                <div className='instr'>
                    {props.isSignIn
                        ? <p className='step'>
                            <Translated id='app.sign.enter' />
                        </p>
                        : <p className='step'>
                            <Translated id='app.sign.create' />
                        </p>}
                </div>

                <div className='login-box'>
                    <input
                        ref={inputRef}
                        type='text'
                        placeholder={translated('app.sign.enter-email')}
                        value={login}
                        // autoFocus
                        onChange={(e) => handleLoginChange(e.target.value)}
                        onKeyDown={(e) => handleLoginKeyDown(e)}
                    />

                    {error &&
                        <div className='error'>
                            {error}
                        </div>}
                </div>

                <div className='button-box'>
                    <button
                        onClick={() => handleAuth()}
                        className='btn-gradient'
                        disabled={!login || isCheckingLogin}>
                        {isCheckingLogin ? null : <Translated id='app.button.next' />}
                    </button>

                    <InlineLoader
                        isShow={isCheckingLogin}
                        color={colors.svRed} />
                </div>
            </div>
        </Slide>)
}

export default Sign
